import React, { useState } from "react";
import "./styles.css";

import moment from "moment";
import { CImage } from "@coreui/react";
import TrashSVG from "../../assets/trash.svg";
import {
  deleteImageByPerson,
  deletePersonByIdTable,
} from "../../services/httpRequest";
import { notification, Popconfirm } from "antd";
import { useNavigate } from "react-router-dom";

const AdminTableSelectedData = ({
  tableData = [],
  update = () => {},
  openModal = () => {},
}) => {
  const navigate = useNavigate();
  const handleImageDelete = async (id) => {
    await deleteImageByPerson(id)
      .then(() => {
        notification.success({
          message: "Foto deletada com sucesso!",
        });
        update();
      })
      .catch(() => {
        notification.error({
          message: "Erro ao deletar foto!",
        });
      });
  };

  const handleDeletePerson = async (id) => {
    await deletePersonByIdTable(id)
      .then(() => {
        notification.success({
          message: "Usuário deletado com sucesso!",
        });
        navigate("/");
      })
      .catch(() => {
        notification.error({
          message: "Erro ao deletar usuário!",
        });
      });
  };

  return (
    <>
      <div className="AdminTableSelectedData">
        <table>
          <thead>
            <tr>
              <th>Foto</th>
              <th>ID</th>
              <th>Totem</th>
              <th>Unidade</th>
              <th>Data de cadastro</th>
              <th>Hora de cadastro</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((data, index) => (
              <tr key={index}>
                <td>
                  {data.picture === null ? (
                    <div className="ImagePlaceHolder">JPG</div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        openModal();
                      }}
                    >
                      <CImage
                        className="Image"
                        align="center"
                        src={data.picture}
                      />

                      <Popconfirm
                        title="Tem certeza que deseja deletar essa foto?"
                        onConfirm={() => handleImageDelete(data?.id_table)}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "rgb(255, 51, 51)",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            padding: "4px 8px",
                            width: "115px",
                          }}
                        >
                          <label style={{ cursor: "pointer", color: "#fff" }}>
                            Deletar foto
                          </label>
                        </div>
                      </Popconfirm>
                    </div>
                  )}
                </td>
                <td>{data.id_table}</td>
                <td className="text-medium">{data.totem_name}</td>
                <td>{data.unit}</td>
                <td>{moment(data.datetime).format("DD/MM/yyyy")}</td>
                <td>{moment(data.datetime).format("HH:mm")}</td>

                <td>
                  <Popconfirm
                    title="ATENÇÃO!"
                    description="Tem certeza que deseja deletar esse usuário?"
                    onConfirm={() => handleDeletePerson(data?.id_table)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: "rgb(255, 51, 51)",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        padding: "4px 8px",
                      }}
                    >
                      <label style={{ cursor: "pointer", color: "#fff" }}>
                        Deletar usuário
                      </label>
                    </div>
                  </Popconfirm>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AdminTableSelectedData;
